export default __webpack_public_path__ + "static/media/appstore_logo.708e1fae.png";